// Novo componente chamado LoginContent.tsx
import React, { useState } from 'react';
import { Box, Typography, Divider, TextField, Button, useTheme, Card, CardContent } from '@mui/material';
import { Cancel, Send } from '@mui/icons-material';

interface RecoveryContentProps {
    handleSubmitNewPassword: (newPassword: string) => void;
    passwordError: string;
    error: boolean;
    removeTokenFromURL: () => void;
}

export const NewPasswordForm: React.FC<RecoveryContentProps> = ({
    handleSubmitNewPassword,
    removeTokenFromURL,
    passwordError,
    error
}) => {
  const theme = useTheme();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorReset, setErrorReset] = useState('');
  const [errorResetBoolean, setErrorResetBoolean] = useState(Boolean);
  
  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = () => {
    if (password.length < 5) {
      setErrorReset('A senha deve ter ao menos 5 digitos.');
      setErrorResetBoolean(true);
    } else if (password !== confirmPassword) {
      setErrorReset('As senhas não coincidem.');
      setErrorResetBoolean(true);
    } else {
      setPassword('');
      setConfirmPassword('');
      setErrorReset('');
      handleSubmitNewPassword(password);
    }
  };

  return (
    <Card>
        <CardContent>
            <Box padding={1}>
                <Box display={'flex'} flexDirection={'column'} gap={2} width={250}>
                    <Box>
                        <Typography variant='h5' align='left' color={theme.palette.primary.main}>
                            Recuperação de Senha
                        </Typography>
                        <Typography variant='body1' align='left'>
                            Informe sua nova senha
                        </Typography>
                        <Divider flexItem variant='fullWidth' orientation='horizontal' color={theme.palette.primary.main} />
                    </Box>

                    <TextField
                        error={errorResetBoolean}
                        fullWidth
                        label='Senha'
                        type='password'
                        value={password}
                        onChange={handlePasswordChange}
                        />
                    <TextField
                        error={errorResetBoolean}
                        fullWidth
                        label='Confirmação de senha'
                        type='password'
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                    />

                </Box>
                {errorReset ? (<><Typography variant='body2' color={'red'}>{errorReset}</Typography></>) : null}
                {error ? (<><Typography variant='subtitle1' color={'red'}>{passwordError}</Typography></>) : null}
                <Box width={'100%'} display={'flex'} justifyContent={'center'} flexDirection={'row'} gap={2} marginTop={2}>
                    <Button startIcon={<Cancel />} variant='contained' fullWidth onClick={removeTokenFromURL}>
                        Cancelar
                    </Button>
                    <Button startIcon={<Send />} variant='contained' fullWidth onClick={handleSubmit}>
                        Enviar
                    </Button>
                </Box>
            </Box>
        </CardContent>
    </Card>
  );
};